module.exports = __webpack_public_path__ + "static/media/funnel-dollar.0d84b440.svg";